import { Button } from "@commonlibs";
import styled, { css } from "styled-components";

export const CancelButton = styled(Button)(
    ({ theme }) => css`
        background-color: #ffffff !important;
        border: 1px solid ${theme.palette.primary};
        :hover {
            background-color: #ecececff !important;
        }
    `,
);
